export default __webpack_public_path__ + "static/media/ImageAutomationloader.8e9afb89.gif";